import React from 'react';
import { Award, Users, Globe, Heart } from 'lucide-react';

export const About = () => {
  const highlights = [
    { icon: <Award size={24} />, text: '13+ Jahre Erfahrung' },
    { icon: <Globe size={24} />, text: 'Ausbildung in DE, USA, Russland' },
    { icon: <Users size={24} />, text: 'Workshops & Seminare' },
    { icon: <Heart size={24} />, text: 'Ganzheitlicher Ansatz' }
  ];

  return (
    <section id="uber-alex" style={{
      padding: 'var(--spacing-giant) 0'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: 'var(--spacing-xl)',
          alignItems: 'center'
        }}>
          {/* Profile Image */}
          <div style={{
            borderRadius: '32px',
            minHeight: '400px',
            overflow: 'hidden',
            boxShadow: '0 4px 16px rgba(0, 69, 52, 0.2)'
          }}>
            <img 
              src="https://customer-assets.emergentagent.com/job_haltung-reset/artifacts/htqoi6jx_IMG_0896.jpeg"
              alt="Alex beim Training mit Kettlebell"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block'
              }}
            />
          </div>

          {/* Content */}
          <div>
            <h2 className="display-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
              Über Alex
            </h2>
            <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
              Mit über 13 Jahren Erfahrung in funktionellem Training und Physiotherapie habe ich mit Büroangestellten, Athleten, Einsteigern und Schmerzpatienten gearbeitet.
            </p>
            <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
              Meine Ausbildung in Deutschland, den USA und Russland hat mir ein tiefes Verständnis für Bewegung und Körpermechanik gegeben. Durch eigene Verletzungen und Rehabilitation weiß ich genau, wie es sich anfühlt, mit Schmerzen zu kämpfen.
            </p>
            <p className="body-medium" style={{ marginBottom: 'var(--spacing-large)' }}>
              <strong>Meine Philosophie:</strong> Wahre Stärke bedeutet schmerzfreie, freie Bewegung. Nicht maximale Last, sondern optimale Kontrolle.
            </p>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: 'var(--spacing-medium)'
            }}>
              {highlights.map((item, index) => (
                <div key={index} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--spacing-small)',
                  padding: 'var(--spacing-small)',
                  background: 'var(--bg-subtle)',
                  borderRadius: '20px'
                }}>
                  <div style={{ color: 'var(--brand-dark)' }}>
                    {item.icon}
                  </div>
                  <span className="body-medium" style={{ fontWeight: 500 }}>
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};